import React, { useEffect, useRef, useState } from "react";
import Layout from "../Layout/Layout";
import { api } from "../actions/api";
import { useLocation, useNavigate } from "react-router-dom";
import html2pdf from "html2pdf.js";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import ShareDocumentModal from "../Components/ShareDocumentModal";

export default function AssessmentCompletedView() {
  const [assessmentDetails, setAssessmentDetails] = useState([]);
  const [isGenerating, setIsGenerating] = useState(false);
  const location = useLocation();
  const idArray = location.state?.id || [];

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [fileToShare, setFileToShare] = useState(null);
  const [titleToShare, setTitleToShare] = useState("Share you Assessment");
  const [contentToShare, setContentToShare] = useState("");

  const sliderSettings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  const navigate = useNavigate();
  const pdfRef = useRef(null);

  const handleDownloadPDF = () => {
    setIsGenerating(true);
    if (!pdfRef.current) return;

    const clonedContent = pdfRef.current.cloneNode(true);
    const style = document.createElement("style");
    style.innerHTML = `
      .col-md-6{
        width: 100% !important;
      }

      .page-break {
        page-break-before: always; /* Forces a new page */
      }

      .no-break {
        page-break-inside: avoid; /* Prevents cutting inside this element */
      }

      .habit-sub-card{
        page-break-inside: avoid;
      }

      .assessment-view-complete{
        max-width: 100%;
        padding: 20px;
        background: #121e29;
      }
    `;
    clonedContent.prepend(style);

    const opt = {
      margin: 0,
      filename: "assessment-summary.pdf",
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: {
        scale: 2,
        useCORS: true,
      },
      jsPDF: {
        unit: "in",
        format: "a4",
        orientation: "portrait",
      },
    };

    html2pdf()
      .set(opt)
      .from(clonedContent)
      .save()
      .then(() => {
        setIsGenerating(false);
      });
  };

  const handleGenerateAndOpenModal = async () => {
    if (!pdfRef.current) return;

    const clonedContent = pdfRef.current.cloneNode(true);

    const elementToRemove = clonedContent.querySelectorAll(
      ".btn.d-flex.justify-content-center.align-items-center.rounded-circle",
    );
    elementToRemove.forEach((el) => el.remove());

    const buttonToRemove = clonedContent.querySelector(".btn-3.btn-1-primary");
    if (buttonToRemove) {
      buttonToRemove.remove();
    }

    const style = document.createElement("style");
    style.innerHTML = `
      .col-md-6{
        width: 100% !important;
      }

      .page-break {
        page-break-before: always; /* Forces a new page */
      }

      .no-break {
        page-break-inside: avoid; /* Prevents cutting inside this element */
      }

      .habit-sub-card{
        page-break-inside: avoid;
      }

      .assessment-view-complete{
        max-width: 100%;
        padding: 20px;
        background: #121e29;
      }
    `;
    clonedContent.prepend(style);

    const options = {
      margin: 0,
      filename: "assessment-report.pdf",
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { scale: 2 },
      jsPDF: { unit: "in", format: "letter", orientation: "portrait" },
    };

    try {
      const pdfBlob = await html2pdf()
        .from(clonedContent)
        .set(options)
        .outputPdf("blob");

      // Create a File object from the Blob
      const pdfFile = new File([pdfBlob], "assessment-report.pdf", {
        type: "application/pdf",
      });
      setFileToShare(pdfFile);
      setIsModalOpen(true);
    } catch (error) {
      console.error("Error generating PDF:", error);
    }
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setFileToShare(null); // Clear the file after closing the modal
  };

  const retakeAssement = () => {
    if (assessmentDetails.length) {
      let assessment = assessmentDetails[0];
      navigate("/assessment-view", {
        state: {
          id: 1,
          incomplete_id: assessment.assessment_score_id,
          assessment_status: "retake",
        },
      });
    }
  };

  useEffect(() => {
    const fetchAssessmentData = async (id) => {
      try {

        const response = await api.get(`/user/assessments/details`, {
          params: {
            user_assessment_score_ids: id,
          },
        });


        setAssessmentDetails(response.data.data);
      } catch (err) {
        console.error("Error fetching assessments:", err);
      }
    };

    fetchAssessmentData(idArray);
  }, [idArray]);

  return (
    <Layout>
      <div className="page-content">
        <div className="assessment-content">
          <div
            className="d-flex gap-3 align-items-center mb-3 mb-md-4"
            style={{ cursor: "pointer" }}
            onClick={() => navigate("/assessment")}
          >
            <img src="/icons/header-arrow-back.svg" alt="" />
            <h1
              className="text-heading-h2 mb-0"
              style={{ color: "#e6ecf1", textTransform: "capitalize" }}
            >
              Assessment
            </h1>
          </div>

          <div className="assessment-view">
            {assessmentDetails.length > 0 ? (
              <Slider {...sliderSettings}>
                {assessmentDetails.map((assessmentDetails, index) => (
                  <div key={index}>
                    <div className="page">
                      <div
                        className="d-flex flex-column gap-4 align-items-center"
                        style={{ marginBottom: "32px" }}
                      >
                        <h3
                          className="text-body-b2 mb-0"
                          style={{
                            color: "var(--Text-50, #e6ecf1)",
                            textTransform: "capitalize",
                          }}
                        >
                          {assessmentDetails?.assessment_name}
                        </h3>
                        <div className="assessment-top-progress-bar">
                          <div
                            className="assessment-top-progressed"
                            style={{
                              width: `100%`,
                            }}
                          ></div>
                        </div>
                      </div>

                      <div
                        className="d-flex justify-content-end gap-2"
                        style={{ marginBottom: "28px", marginTop: "28px" }}
                      >
                        <button
                          className="btn-4 btn-4-secondary text-body-b3 no-print"
                          onClick={handleDownloadPDF}
                          disabled={isGenerating}
                        >
                          {isGenerating ? "Generating PDF..." : "Download PDF"}
                        </button>
                        <button
                          className="btn-3 btn-1-primary text-body-b3"
                          onClick={retakeAssement}
                        >
                          Retake
                        </button>
                        <button
                          className="btn-4 btn-4-secondary text-body-b3 no-print share-button"
                          onClick={handleGenerateAndOpenModal}
                        >
                          <img
                            src="/icons/journal-share-icon.svg"
                            alt="share"
                            style={{ cursor: "pointer" }}
                          />
                        </button>
                      </div>
                      <div
                        className="d-flex assessment-view-complete"
                        ref={pdfRef}
                      >
                        <div className="selection-complete-assess-card flex-shrink-0">
                          <div className="your-score-card-container ">
                            <div className="your-score-card">
                              <div className="d-flex align-items-center flex-column gap-3">
                                <h1 className="your-score-h1 mb-0">
                                  Your Score
                                </h1>
                                <div className="total-score-view">
                                  <h1 className="mb-0">
                                    {assessmentDetails?.total_obtained_score} /
                                    {assessmentDetails?.total_score}
                                  </h1>
                                </div>
                                <h3
                                  className="text-body-b2 mb-0"
                                  style={{
                                    fontWeight: "700",
                                    color: "#e6ecf1",
                                    textAlign: "center",
                                  }}
                                >
                                  {assessmentDetails?.total_obtained_score >=
                                  Math.floor(
                                    assessmentDetails?.total_score * 0.83,
                                  )
                                    ? "You're inside of prosperity!!"
                                    : assessmentDetails?.total_obtained_score >=
                                        Math.floor(
                                          assessmentDetails?.total_score * 0.5,
                                        )
                                      ? "You're in abundance!"
                                      : "Keep working - you're in scarcity"}
                                </h3>
                              </div>
                            </div>
                            <div className="your-score-text-container">
                              <h1 className="mb-0">Congratulations!</h1>

                              {assessmentDetails?.growth !== undefined &&
                                assessmentDetails.growth !== 0 && (
                                  <div
                                    className="d-flex align-items-center"
                                    style={{ gap: "6px" }}
                                  >
                                    {assessmentDetails.growth > 0 ? (
                                      <img
                                        src="/icons/assesssment-chart-increase.svg"
                                        alt=""
                                      />
                                    ) : (
                                      <img
                                        src="/icons/assesssment-chart-decrease.svg"
                                        alt=""
                                      />
                                    )}

                                    <h4 className="mb-0">
                                      {assessmentDetails.growth > 0
                                        ? `+${assessmentDetails.growth}%`
                                        : `-${assessmentDetails.growth}%`}
                                    </h4>
                                  </div>
                                )}

                              <span
                                className="text-body-b2"
                                style={{
                                  color: "#acb2b7",
                                  textAlign: "center",
                                }}
                              >
                                You scored <span> </span>
                                {assessmentDetails?.total_score > 0
                                  ? (
                                      (assessmentDetails.total_obtained_score /
                                        assessmentDetails.total_score) *
                                      100
                                    ).toFixed(2) + "%"
                                  : "N/A"}
                                <span> </span> on this assessment.
                              </span>
                            </div>
                          </div>
                        </div>

                        <div className="score-data-container">
                          <div className="d-flex flex-column gap-3 mb-4">
                            <h3
                              className="text-body-b2 mb-0"
                              style={{ fontWeight: "700", color: "#e6ecf1" }}
                            >
                              Score Overview
                            </h3>
                            <div
                              className="d-flex gap-2 text-body-b2 flex-wrap"
                              style={{ color: "#acb2b7" }}
                            >
                              <span>
                                0-
                                {Math.floor(
                                  assessmentDetails?.total_score * 0.5,
                                )}{" "}
                                = Scarcity
                              </span>
                              <span>
                                {Math.floor(
                                  assessmentDetails?.total_score * 0.5,
                                ) + 1}
                                -
                                {Math.floor(
                                  assessmentDetails?.total_score * 0.83,
                                )}{" "}
                                = Abundance
                              </span>
                              <span>
                                {Math.floor(
                                  assessmentDetails?.total_score * 0.83,
                                ) + 1}
                                -{assessmentDetails?.total_score} = Prosperity
                              </span>
                            </div>
                          </div>
                          <h3
                            className="text-heading-h3 mb-3"
                            style={{ color: "#e6ecf1" }}
                          >
                            Question Scores
                          </h3>
                          <div className="different-score-container">
                            {assessmentDetails?.questions.map(
                              (question, index) => {
                                const score =
                                  typeof question.answer === "object"
                                    ? question.answer.score
                                    : typeof question.answer === "number"
                                      ? question.answer
                                      : 1;

                                return (
                                  <div className="score-card" key={index}>
                                    <div className="score-for-cards">
                                      {score}
                                    </div>
                                    <h3
                                      className="text-body-b3 mb-0"
                                      style={{ color: "#c1c9d1" }}
                                    >
                                      {question.title}
                                    </h3>
                                  </div>
                                );
                              },
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </Slider>
            ) : (
              <div className="text-center py-5">
                <div className="loader-container">
                  <div className="loader"></div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      {isModalOpen && (
        <>
          <ShareDocumentModal
            show={isModalOpen}
            title={titleToShare}
            file={fileToShare}
            content={contentToShare}
            onClose={handleCloseModal}
          />
          <div className="modal-backdrop show"></div>
        </>
      )}
    </Layout>
  );
}
